import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconLeadPending = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm0-3.294a8.706 8.706 0 1 0 0-17.412 8.706 8.706 0 0 0 0 17.412Z"
	})
});
export default SvgIconLeadPending;
